<app-page-title title="Boîte de dépôt de documents"
  desc="Pour déposer de nouveaux documents, il vous suffit d'envoyer un email avec des pièces jointes aux adresses indiquées ci-dessous !"></app-page-title>

<ng-container *ngIf="loading">
  <app-data-loading></app-data-loading>
</ng-container>

<ng-container *ngIf="!loading">
  <div *ngIf="!loading && data && data.length > 0; else noProperty" class="container-fluid">
    <mat-accordion multi="true">
      <mat-expansion-panel *ngFor="let row of data" [expanded]="expanded[row.uid]">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="name">{{ row.name }}</span>
            <span class="mail"><a href="mailto:{{ row.dropboxAddressMailto }}">{{ row.dropboxAddress }}</a></span>
          </mat-panel-title>
          <mat-panel-description class="no-mobile">
            {{ row.description }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <app-dropbox-doc-table [prop]="row.prop"></app-dropbox-doc-table>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-container>

<ng-template #noProperty>
  <span class="no-content">Vous ne disposez d'aucun accès sur un bien certifié</span>
</ng-template>